import { render, staticRenderFns } from "./CreditsTitle.vue?vue&type=template&id=224ba83f&scoped=true"
import script from "./CreditsTitle.vue?vue&type=script&lang=js"
export * from "./CreditsTitle.vue?vue&type=script&lang=js"
import style0 from "./CreditsTitle.vue?vue&type=style&index=0&id=224ba83f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224ba83f",
  null
  
)

export default component.exports